import React, { useEffect, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function SshPasswordField({ sshPassword, anotherSectionActive, centralCredential, error, disabled }) {

    const [disableValue, setDisableValue] = useState(disabled)
    useEffect(() => {
        if (anotherSectionActive) {
            validationService.cleanValidation('sshPassword');
            onChange('');
        }
        else if (centralCredential && centralCredential.id > 0) {
            validationService.cleanValidation('sshPassword');
            onChange('');
            setDisableValue(true);
        } 
        else {
            validationService.validateNotEmpty(sshPassword, 'sshPassword');
            setDisableValue(false);
        }
        return () => validationService.cleanValidation('sshPassword');
    }, [sshPassword, anotherSectionActive, centralCredential])

    // useEffect(() => {
    //     if(centralCredential && centralCredential.id > 0) {
    //         setDisableValue(true);
    //         //modalDataService.changeSshPassword('')
    //     }
    //     else {
    //         setDisableValue(false);
    //         //modalDataService.changeSshPassword("");
    //     }
    // }, [centralCredential])

    const onChange = (value) => modalDataService.changeSshPassword(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="ssh_passowrd-key">Password <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="ssh_passowrd-key"
                    type="password"
                    disabled={disableValue}
                    value={sshPassword}
                    placeholder="••••••••"
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("SshPaswordlessKeyField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    const anotherSectionActive = !!addDeviceModal.sshPasswordlessKey;
    return {
        sshPassword: addDeviceModal.sshPassword || '',
        centralCredential: addDeviceModal.centralCredential || null,
        error: validation.sshPassword,
        anotherSectionActive
    }
}

export default connect(mapStateToProps)(SshPasswordField);
